module.exports = __webpack_public_path__ + "images/ovz_small455bcbb4b454d73f0099b48bfb63922d.png";